// メッセージMap
export const MessageMap = {
    "search_accept_period_start": "受入・就業開始年月"
};
